import type { INotExcludedUser } from "~/utils/interfaces/users-interfaces";

/**
 * How a user is named on screen: their display value, else "Prénom Nom", else their e-mail.
 */
export function userDisplayName(user: Record<string, any>): string {
  const display = user.displayValue;
  if (display) return display;
  return [user.firstname, user.lastname].filter(Boolean).join(" ") || user.email || "";
}

/**
 * The boundary into `INotExcludedUser`. Both sources are camelCase SDK models —
 * `CollaboratorListItem` (`/users/collaborators`) and `AvailableUserResponse`
 * (`/users/getUsersNotExcluded`), which name the manager differently: first/last name on one,
 * e-mail + display value on the other. Whichever half the payload omits stays null.
 */
export function toCompanyUser(user: Record<string, any>): INotExcludedUser {
  return {
    userId: user.userId,
    email: user.email,
    firstname: user.firstname,
    lastname: user.lastname,
    employeeNumber: user.employeeNumber,
    displayValue: user.displayValue,
    managerEmail: user.managerEmail ?? null,
    managerFirstname: user.managerFirstname ?? null,
    managerLastname: user.managerLastname ?? null,
    managerDisplayValue: user.managerDisplayValue ?? null,
  };
}
